import { CdkScrollable } from '@angular/cdk/scrolling';
import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';

import { ErrorDialogData } from '@VineyardLib/data/error-dialog-data';
import { messageData } from '@VineyardLib/data/message-data';
import { LabelTranslatePipe } from '@VineyardLib/pipes/labelTranslate.pipe';
import { MessageTranslatePipe } from '@VineyardLib/pipes/messageTranslate.pipe';

/**
 * エラーダイアログ
 */
@Component({
  selector: 'app-error-dialog-component',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  imports: [
    // AngularCDK
    CdkScrollable,
    // AngularMaterial
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    // 内部パイプ
    DatePipe,
    LabelTranslatePipe,
    MessageTranslatePipe,
  ],
})
export class ErrorDialogComponent {
  data = inject<ErrorDialogData>(MAT_DIALOG_DATA);

  messageList: messageData[] = [];
  /**
   * constructor
   * @param data エラーダイアログの表示データ
   */
  constructor() {
    const data = this.data;

    this.messageList = this.messageList.concat(data.message); // messageDataとmessageData[]のどちらが来ても動作するように配列に変換する
  }
}
